import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatBadgeModule} from '@angular/material/badge';
import {MatTooltipModule} from '@angular/material/tooltip';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {ImportFileComponent} from './import-file.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ComponentSetupModule} from '../../../../formbird-sc-shared/src/lib/component-setup.module';
import {ValidationMessageModule} from '../../../../formbird-sc-shared/src/lib/components/validation/validation-message.module';
import {CustomElementService} from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';
import {ngfModule} from 'angular-file';
import { default as pjson } from '../../../../../package.json';

@NgModule({
  declarations: [
    ImportFileComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatBadgeModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentSetupModule,
    ValidationMessageModule,
    MatTooltipModule,
    ngfModule
  ],
  providers: []
  // do not bootstrap the app component when exporting custom elements because an Angular app doesn't run. An ngDoBootstrap
  // function is defined that does nothing.
  // bootstrap: [AppComponent]
})
export class ImportFileModule {
  constructor(private injector: Injector, private customElementService: CustomElementService) {
    customElementService.convertToCustomElement(ImportFileComponent, 'sc-import-file', this.injector, pjson.version);
    customElementService.convertToCustomElement(ImportFileComponent, 'sc-import-csv', this.injector, pjson.version);
    customElementService.convertToCustomElement(ImportFileComponent, 'sc-import-json', this.injector, pjson.version);

  }
}
